module.exports = __webpack_public_path__ + "static/media/atp-250.8e77465f.png";